import { News, Filters } from '@gower/cm-mdp-sdk/news';
import { MessageBox } from '@gower/react-ui/message-box';
import { expose, SubStore } from '@gower/react-ui/store';
import { DataGridStore } from '@gower/react-ui/template/data-grid';
import { NewsProvider } from 'app/news-provider';

export class NewSubStore extends SubStore<NewsStore> {
    public get Selected () { return this.MainStore.Selected; }
}

class NewsStore extends DataGridStore( News, Filters, { viewName: 'NEWS' } )
{
    public Mode: 'edit' | 'create' | 'list' = 'list';
    public Selected: News = null;

    onAfterRender () {
        this.list();
    }

    edit ( news: News ) {
        this.Selected = news;
        this.Mode = 'edit';
    }

    create () {
        this.Selected = null;
        this.Mode = 'create';
    }

    list ( newItem?: News ) {
        this.Selected = null;
        if ( newItem )
            this.Items.unshift( newItem );
        this.Mode = 'list';
    }

    async active ( item: News ) {
        if ( item && !item.Status.isActive ) {
            item.Status = News.VO.Status.Active;
            const result = await item.save();
            if ( !result.result ) {
                await MessageBox.Error( result.errorList );
            } else {
                await NewsProvider.activeForcedReload();
            }
        }
    }

    async disable ( item: News ) {
        if ( item && !item.Status.isDeactivated ) {
            item.Status = News.VO.Status.Deactivated;
            const result = await item.save();
            if ( !result.result ) {
                await MessageBox.Error( result.errorList );
            } else {
                await NewsProvider.activeForcedReload();
            }
        }
    }
}

export const { useStore, provider } = expose( NewsStore );